module.exports = __webpack_public_path__ + "static/media/full-screen-image-3.0400a729.jpg";